<h5>{{ title }}</h5>
<p>{{ description }}</p>

<div class="w-full flex flex-row items-center gap-4 pt-4">
  @if (showConfirm) {
    <button (click)="onConfirm()"
            class="btn btn-primary flex flex-row gap-2 items-center min-w-[3rem]"
            style="border-radius: 0.5rem;padding: 0.5rem 1rem">
      <img alt="Icon" class="filter-neutral-100 h-4" src="/assets/icons/feather/send.svg">
      <span class="hidden lg:block cd-text-md truncate">{{ confirmText }}</span>
    </button>
  }

  @if (showCancel) {
    <button (click)="onClose()"
            class="btn btn-primary-soft flex flex-row gap-2 items-center min-w-[3rem]"
            style="border-radius: 0.5rem;padding: 0.5rem 1rem">
      <img alt="Icon" class="filter-primary-600 h-4" src="/assets/icons/feather/x.svg">
      <span class="hidden lg:block cd-text-md truncate capitalize">{{ cancelText }}</span>
    </button>
  }
</div>
